export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-sm font-semibold text-orange-600 tracking-widest uppercase mb-4 block">
              About VE Goodies
            </span>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Your Trusted Vending Partner in DFW
            </h2>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              VE Goodies is a premier vending machine service provider dedicated to bringing convenience, quality, and innovation to businesses across the Dallas-Fort Worth metroplex. We specialize in providing state-of-the-art vending solutions with modern cashless payment systems, smart technology, and healthy product options featuring top brands like Coca-Cola, Pepsi, Frito-Lay, Doritos, Cheetos, Lay's, Red Bull, Monster Energy, Gatorade, Dasani, Aquafina, Kind Bars, Nature Valley, and many more.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Our mission is to enhance workplace satisfaction by offering fresh, nutritious snacks and beverages from trusted brands including Snickers, M&M's, Reese's, Twix, Kit Kat, Sprite, Dr Pepper, Mountain Dew, Vitamin Water, Smartwater, Clif Bars, and PopCorners through cutting-edge vending machines equipped with touchless payment options, AI-powered inventory management, and 24/7 support. We handle everything from installation to maintenance, ensuring your team always has access to quality refreshments.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-100 rounded-xl p-6">
                <div className="text-4xl font-bold text-orange-600 mb-2">250+</div>
                <div className="text-sm text-gray-700 font-medium">Happy Clients</div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-100 rounded-xl p-6">
                <div className="text-4xl font-bold text-orange-600 mb-2">380+</div>
                <div className="text-sm text-gray-700 font-medium">Machines Installed</div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-100 rounded-xl p-6">
                <div className="text-4xl font-bold text-orange-600 mb-2">24/7</div>
                <div className="text-sm text-gray-700 font-medium">Support Available</div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-100 rounded-xl p-6">
                <div className="text-4xl font-bold text-orange-600 mb-2">100%</div>
                <div className="text-sm text-gray-700 font-medium">Satisfaction Rate</div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <div className="flex items-center bg-gray-50 px-4 py-3 rounded-lg">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-shield-check-line text-orange-600 text-lg"></i>
                </div>
                <span className="text-sm font-medium text-gray-700">Licensed &amp; Insured</span>
              </div>
              <div className="flex items-center bg-gray-50 px-4 py-3 rounded-lg">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-award-line text-orange-600 text-lg"></i>
                </div>
                <span className="text-sm font-medium text-gray-700">Industry Certified</span>
              </div>
              <div className="flex items-center bg-gray-50 px-4 py-3 rounded-lg">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-leaf-line text-orange-600 text-lg"></i>
                </div>
                <span className="text-sm font-medium text-gray-700">Eco-Friendly Options</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative w-full h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/156a83a3bc4f1c01ced81e469a5a9f04.jpg"
                alt="VE Goodies Team - Diverse everyday people enjoying vending solutions"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-full mr-3">
                  <i className="ri-customer-service-2-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">24/7</div>
                  <div className="text-xs text-gray-600">Customer Support</div>
                </div>
              </div>
              <p className="text-xs text-gray-600">
                Our dedicated team is always ready to assist you with any vending needs
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
